import React from 'react'
import { Route } from 'react-router'
//profile containers
import ProfileShowContainer from '../components/dashboard/ProfileShowContainer'
import ProfileEditContainer from '../components/dashboard/ProfileEditContainer'

export const ShowProfileContainerRoute = (
  <Route path="profile" component={ProfileShowContainer} />
)

export const ProfileEditContainerRoute = (
  <Route path="profile/edit" component={ProfileEditContainer} />
)



// WEBPACK FOOTER //
// ./src/routes/profileRoutes.js